module.exports = __webpack_public_path__ + "b39080d0042a5063b41a5fb5dc255ac3.fbx";